import React from 'react'
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { connect } from 'react-redux';
import { setAlerte } from '../redux/actions'

function Alerte({ alertetexte, alertetype, setAlerte }) {
    if (alertetexte === "") {
        return null
    }
    else
        setTimeout(() => {
            setAlerte("", "");
        }, 2000);
    return (

        <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert variant="filled" severity={alertetype}>{alertetexte}</Alert>
        </Stack>
    )
}


function mapStateToProps(state) {

    return {
        alertetexte: state.alertetexte,
        alertetype: state.alertetype,
    }
}


export default connect(mapStateToProps, { setAlerte })(Alerte);

